import { render, staticRenderFns } from "./ShowPropertyFileTypeOptions.vue?vue&type=template&id=4d977d50&scoped=true&"
import script from "./ShowPropertyFileTypeOptions.vue?vue&type=script&lang=js&"
export * from "./ShowPropertyFileTypeOptions.vue?vue&type=script&lang=js&"
import style0 from "./ShowPropertyFileTypeOptions.vue?vue&type=style&index=0&id=4d977d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d977d50",
  null
  
)

export default component.exports